<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="教师推荐">
        <a-list
          :grid="{ gutter: 24, lg: 3, md: 1, sm: 1, xs: 1 }"
          :dataSource="dataSource"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-card :hoverable="true">
              <template class="ant-card-extra" slot="extra">
                <span class="work-type">
                  <a-tag color="blue">
                    {{ item.codeType_dictText }}
                  </a-tag>
                </span>
                <a-divider type="vertical" />
                <span class="author">{{ item.realname }}</span>
                <a-divider type="vertical" />
                <span class="create-time">{{ item.createTime.split(" ")[0] }}</span>
              </template>

              <a-card-meta>
                <div style="margin-bottom: 3px" slot="title">
                  <a :href="getEditorHref(item)" target="_blank">{{ item.workName }}</a>
                </div>
                <!-- <a-avatar class="card-avatar" slot="avatar" :src="item.avatar" size="small" /> -->
                <div class="meta-cardInfo" slot="description">
                  <a :href="getEditorHref(item)" target="_blank">
                    <img :src="item.workCover_url" />
                  </a>
                </div>
              </a-card-meta>
            </a-card>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <!-- <a-tab-pane key="2" tab="社区精选">
      </a-tab-pane> -->
    </a-tabs>
  </div>
</template>

<script>
import Vue from "vue"
import { USER_DEPART } from "@/store/mutation-types" 
import { getAction, downFile } from "@/api/manage";
export default {
  name: "StudentGreatWork",
  data() {
    return {
      dataSource: [],
    };
  },
  created() {
    this.getGreatWork();
  },
  methods: {
    getGreatWork() {
      let departIds 
      let userDepart = Vue.ls.get(USER_DEPART)
      if(userDepart){
        departIds = userDepart.map(x=>x.id).join(",")
      }else{
        departIds = ""
      }
      
      getAction("/teaching/teachingWork/choiceness?time=now", {
        pageNo: 1,
        pageSize: 99,
        departIds: departIds
      }).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
        getEditorHref(item){
      switch(item.codeType){
        case 1:
          return '/scratch3/index.html?workId='+item.id
          break;
        case 2:
          return '/scratch3/index.html?workId='+item.id
          break;
        case 3:
          return '/scratchjr/editor.html?mode=edit&filepath=' + item.workFile_url
          break;
        case 4:
          return '/onlinecode/index.html?lang=turtle&workId=' + item.id
          break;
        case 5:
          return '/onlinecode/index.html?lang=python&workId=' + item.id
          break;
        case 6:
          return '/onlinecode/index.html?lang=c&workId=' + item.id
          break;
        case 7:
          return '/onlinecode/index.html?lang=cpp&workId=' + item.id
          break;
        case 8:
          return '/onlinecode/index.html?lang=java&workId=' + item.id
          break;
        case 10:
            return '/blockly/index.html?lang=zh-hans&workId=' + item.id
        default:
          return item.workFile_url
      }
    }
  },
};
</script>

<style lang="less" scoped>

.ant-card-extra{
    width: 100%!important;
    .work-type{
      float: left;
    }
    .create-time{
          float: right;
    }
  }
  .meta-cardInfo {
    zoom: 1;
    margin-top: 16px;
    img {
      width: 100%;
    }
    > div {
      position: relative;
      text-align: left;
      float: left;
      width: 50%;

      p {
        line-height: 32px;
        font-size: 24px;
        margin: 0;

        &:first-child {
          color: rgba(0, 0, 0, 0.45);
          font-size: 12px;
          line-height: 20px;
          margin-bottom: 4px;
        }
      }
    }
  }
</style>